export default {
    GET_SHIPPING_LABELS_REQUEST: state => {
        state.shippingLabelsLoading = true
    },
    GET_SHIPPING_LABELS_SUCCESS: (state, data) => {
        state.shippingLabels = data.results
        state.shippingLabelsLoading = false
    },
    GET_SHIPPING_LABELS_FAILURE: state => {
        state.shippingLabelsLoading = false
    },
    GET_SHIPPING_LABEL_STATUSES: (state, data) => {
        state.shippingLabelStatuses = data.results
    },
    GET_SHIPPING_LABEL_TYPES: (state, data) => {
        state.shippingLabelTypes = data.results
    },
    GET_SHIPPING_LABEL_TEMPLATES_SUCCESS: (state, data) => {
        state.shippingLabelTemplates = data.results
    }
}